import instance from '../axios';

export const getAll = async () => {
  const response = await instance.get(`acc-transactions/`);
  return response.data;
};
export const insert = async (data) => {
  const response = await instance.post(`acc-transactions/`, data);
  return response;
};
export const update = async (data) => {
  const response = await instance.put(`acc-transactions/`, data);
  return response;
};
export const remove = async (id) => {
  const response = await instance.delete(`acc-transactions/` + id);
  return response;
};

export const uploadImage = async (imageUpload, dir, trxID, date) => {
  var formData = new FormData(); 
  formData.set( 
      "myFile", 
      imageUpload, 
      imageUpload.name 
  ); 
  formData.append( 
      "targetDir", 
      dir           
  );
  formData.append( 
      "trxID", 
      trxID           
  );
  formData.append( 
      "date", 
      date           
  );
  const response = await instance.post(`acc-transactions/upload-image`, formData);
  return response;
}